import { useState } from 'react';
import type { AbgleichZeile } from './entities/Mitarbeiterabgleich';
import { ermittleZielStandort, ordneStandorteZu } from './uebernahme';

export type OffeneZuordnung = {
  mitStandort: AbgleichZeile[];
  ohneStandort: AbgleichZeile[];
};

export function useStandortZuordnung(
  uebernehme: (zeilen: AbgleichZeile[]) => void,
) {
  const [offeneZuordnung, setOffeneZuordnung] =
    useState<OffeneZuordnung | null>(null);

  const uebernehmeEinzeln = (zeile: AbgleichZeile) => {
    if (ermittleZielStandort(zeile) === null) {
      setOffeneZuordnung({ mitStandort: [], ohneStandort: [zeile] });
      return;
    }
    uebernehme([zeile]);
  };

  const zuordnungFertig = (zuordnung: Record<string, string>) => {
    if (!offeneZuordnung) {
      return;
    }
    uebernehme([
      ...offeneZuordnung.mitStandort,
      ...ordneStandorteZu(offeneZuordnung.ohneStandort, zuordnung),
    ]);
    setOffeneZuordnung(null);
  };

  return {
    offeneZuordnung,
    oeffneZuordnung: setOffeneZuordnung,
    schliesseZuordnung: () => setOffeneZuordnung(null),
    uebernehmeEinzeln,
    zuordnungFertig,
  };
}
